"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let Charts = class Charts extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    openDashboard(...args) {
        const item = args[0];
        item.loading = true;
        this.$fn
            .fetch('get_superset_dashboard_token', { parameters: { id: item.id } })
            .then(resp => window.open(resp.url, "_blank").focus())
            .finally(() => {
            item.loading = false;
        });
    }
    dashboards;
    async $$load_dashboards() {
        return new Promise((resolve, reject) => {
            this.$fn.fetch('list_superset_dashboards')
                .then(p => resolve(_.map(p.result, pp => ({ ...pp, loading: false }))))
                .catch(err => {
                resolve({
                    error: { message: _.get(err, 'response.data.message', err.toJSON().message) }
                });
            });
        });
    }
    ux;
    dataMembers = ['dashboards', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                dashboards: null,
                ux: null,
            },
        };
    }
    async act_8358196963355853_script_2298_getActionArgs_value($event) {
        this.openDashboard($event.scope.item);
    }
    async act_8358196963355853_script_2298_getActionArgs($event) {
        return {
            value: () => this.act_8358196963355853_script_2298_getActionArgs_value($event),
        };
    }
    async evh_8358196963355853_clickPrevent(event, scope) {
        return await this.actions.evh_8358196963355853_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_8358196963355853_script_2298 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8358196963355853_script_2298_getActionArgs,
            events: [],
        });
        const evh_8358196963355853_clickPrevent_2297 = new core_1.actions.EventHandlerImpl({
            action: act_8358196963355853_script_2298,
            event: "click.prevent",
            displayName: "script",
        });
        const evh_8358196963355853_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8358196963355853_clickPrevent_2297],
        });
        return {
            act_8358196963355853_script_2298,
            evh_8358196963355853_clickPrevent_2297,
            evh_8358196963355853_clickPrevent,
        };
    }
};
Charts = __decorate([
    (0, vue_property_decorator_1.Component)()
], Charts);
exports.default = Charts;
vue_property_decorator_1.Vue.component("Charts", Charts);
